// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".FbxQHFJthPsrZIj1SQFx{width:12%}.FbxQHFJthPsrZIj1SQFx,.uBYZwiPQRA2BfMFPgu2D{display:-webkit-box;display:-ms-flexbox;display:flex}.hSBbYTQZAKMDBec5heuF{width:88%}html[dir] .s58y2gmvwUQjvNgqNjCY{background:var(--white)}.s58y2gmvwUQjvNgqNjCY.TmT7vSyPVk7YQl5kxHU1,.s58y2gmvwUQjvNgqNjCY._Axp4102TA0jY61DPXAT{height:76px}.s58y2gmvwUQjvNgqNjCY.Pfwo_Mt9AjgJmlmrHhPp{height:70px}html[dir] .XVDXGrhjad4JQ7Yvo7mC{padding-top:12px}html[dir] .g1IgUKQ6nRInQhpDQmtW.TmT7vSyPVk7YQl5kxHU1{padding-top:6px}html[dir] .g1IgUKQ6nRInQhpDQmtW.Pfwo_Mt9AjgJmlmrHhPp,html[dir] .g1IgUKQ6nRInQhpDQmtW._Axp4102TA0jY61DPXAT{padding-top:2px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"personaCircle": "FbxQHFJthPsrZIj1SQFx",
	"shimmerSecondRow": "uBYZwiPQRA2BfMFPgu2D",
	"secondRowText": "hSBbYTQZAKMDBec5heuF",
	"mailListShimmerContainer": "s58y2gmvwUQjvNgqNjCY",
	"full": "TmT7vSyPVk7YQl5kxHU1",
	"medium": "_Axp4102TA0jY61DPXAT",
	"compact": "Pfwo_Mt9AjgJmlmrHhPp",
	"paddingFirstMessage": "XVDXGrhjad4JQ7Yvo7mC",
	"paddingMessage": "g1IgUKQ6nRInQhpDQmtW"
};
module.exports = ___CSS_LOADER_EXPORT___;
